import { Box, Typography } from "@mui/material";
import React from "react";

import { defaultPaperworkBackgroundData } from "@constants/PatientFormConstants";

import { FormContainer } from "../../common/FormContainer";
import { steps } from "./steps";

interface FollowUpFormProps {
  patientId: string;
  appointmentId?: string | null;
}

/**
 * Follow Up Form Container
 *
 * This component serves as a container for the Follow Up form.
 * It provides the FormOrchestrator context and renders the form steps.
 */
const FollowUpForm: React.FC<FollowUpFormProps> = ({ patientId, appointmentId }) => {
  if (!appointmentId) {
    return (
      <Box sx={{ padding: 3 }}>
        <Typography color="error">Appointment ID required for Follow Up form.</Typography>
      </Box>
    );
  }

  return (
    <FormContainer
      title="Follow Up Form"
      description="Please complete all sections of this form. Your information will help us provide you with the best care possible. Click a completed section to go back and review your answers."
      formType="followUp"
      patientId={patientId}
      appointmentId={appointmentId}
      steps={steps}
      defaultValues={defaultPaperworkBackgroundData}
    />
  );
};

export default FollowUpForm;
